import { render, staticRenderFns } from "./industrialautomation.vue?vue&type=template&id=2e6f5112&scoped=true&"
import script from "./industrialautomation.vue?vue&type=script&lang=js&"
export * from "./industrialautomation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6f5112",
  null
  
)

export default component.exports